import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// 安全解析 localStorage 中的 JSON 数据
const safeJSONParse = (key, defaultValue = {}) => {
  try {
    const item = localStorage.getItem(key)
    if (!item || item === 'undefined' || item === 'null') {
      return defaultValue
    }
    return JSON.parse(item)
  } catch (e) {
    return defaultValue
  }
}

export default new Vuex.Store({
  state: {
    // 支持管理员和医生两种登录类型
    user: safeJSONParse('user_info', { role: 0 }),
    userType: localStorage.getItem('user_type') || '', // 'admin' 或 'doctor'
    sidebarCollapsed: false
  },
  getters: {
    isAdmin: state => state.userType === 'admin',
    isDoctor: state => state.userType === 'doctor',
    currentUser: state => state.user
  },
  mutations: {
    SET_USER(state, { user, userType }) {
      // 确保 user 不为 null/undefined
      const safeUser = user || {}
      state.user = safeUser
      state.userType = userType
      localStorage.setItem('user_info', JSON.stringify(safeUser))
      localStorage.setItem('user_type', userType)
    },
    CLEAR_USER(state) {
      state.user = {}
      state.userType = ''
      localStorage.removeItem('user_info')
      localStorage.removeItem('user_type')
      localStorage.removeItem('token')
    },
    TOGGLE_SIDEBAR(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed
    }
  },
  actions: {
    login({ commit }, data) {
      localStorage.setItem('token', data.token)
      commit('SET_USER', {
        user: data.admin || data.doctor,
        userType: data.userType
      })
    },
    logout({ commit }) {
      commit('CLEAR_USER')
    }
  }
})
